/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import { Form, Select, Spin } from "antd";
import { SEARCH_MEMBERS_VARS, SEARCH_MEMBERS } from "graphql/queries";
import { FaRegUser } from "react-icons/fa";
import { useQuery } from "@apollo/client";
import { UserAvatarWithDetails } from "components/core";

const FormItem = Form.Item;
const Option = Select.Option;

const SelectUsers = (props) => {
  const { organizationId, viewerLoading, formItemLayout, userTaskData } = props;

  const [searchMemberQuery, setSearchMemberQuery] = useState("");
  const [users, setUsers] = useState([]);

  const {
    loading: memberSearchLoading,
    error: memberSearchError,
    data: memberSearchData,
    refetch: memberSearchRefetch,
  } = useQuery(SEARCH_MEMBERS, {
    variables: {
      ...SEARCH_MEMBERS_VARS,
      organizationId: organizationId,
      query: searchMemberQuery,
    },
    skip: !organizationId,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (memberSearchData?.searchMembersForWidget?.items?.length) {
      setUsers(memberSearchData.searchMembersForWidget.items);
    }
  }, [memberSearchData]);

  const initialValues =
    (userTaskData &&
      userTaskData.assignedUsers.length > 0 &&
      userTaskData.assignedUsers.map((assigned) => ({
        key: assigned.id,
        value: assigned?.id,
        label: assigned.fullName,
      }))) ||
    [];

  return (
    <FormItem
      {...formItemLayout}
      label={
        <span style={{ fontSize: 13, fontWeight: "400" }}>
          <FaRegUser style={{ verticalAlign: "middle", marginRight: 7 }} />
          Assigned User(s)
        </span>
      }
      name="assignedUsers"
      rules={[{ type: "array" }]}
      initialValue={initialValues}
    >
      <Select
        showSearch
        showAction={["focus", "click"]}
        mode="multiple"
        labelInValue
        placeholder="Assign users"
        onSearch={(searchItem) => setSearchMemberQuery(searchItem)}
        onDropdownVisibleChange={() => setSearchMemberQuery("")}
        onSelect={() => setSearchMemberQuery("")}
        notFoundContent={
          viewerLoading || memberSearchLoading ? (
            <div style={{ textAlign: "center" }}>
              <Spin size="small" />
            </div>
          ) : null
        }
        style={{ width: "100%" }}
        optionFilterProp="title"
        optionLabelProp="title"
      >
        {users?.map((d) => (
          <Option key={d.user.id} value={d.user.id} title={d.user.fullName}>
            <UserAvatarWithDetails
              fullName={d.user.fullName}
              email={d.user.email}
              showAvatar={false}
              style={null}
            />
          </Option>
        ))}
      </Select>
    </FormItem>
  );
};

export default SelectUsers;
